module.exports = __webpack_public_path__ + "img/pr-8.3f2b21aa.png";